import React, { Component } from "react";
import Select, {components} from "react-select";
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable'

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  // SortableContainerProps,
  // SortEndHandler,
} from 'react-sortable-hoc';

// ### example code async 
// <ReactSelectComponent
//   async
//   value={filter.user}
//   loadOptions={this.loadUserOptions}
//   defaultOptions
//   placeholder="Search User (min 3 Char)"
//   onChange={(e) => setFilter({user: e})}
// />

function arrayMove(array, from, to) {
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}

const SortableMultiValue = SortableElement((props) => {
  // this prevents the menu from being opened/closed when the user clicks
  // on a value to begin dragging it. ideally, detecting a click (instead of
  // a drag) would still focus the control and toggle the menu, but that
  // requires some magic with refs that are out of scope for this example
  const onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableMultiValueLabel = SortableHandle((props) => (
  <components.MultiValueLabel {...props} />
));


class ReactSelectComponent extends Component {

  render() {
    const stylesReactSelect = {
      control: base => ({
        ...base,
        color: "#5c6873",
        minHeight: "40px",
        maxHeight: 'none',
        "&:hover": {
        },
        "&:focus": {
          boxShadow: isInvalid ? '0 0 0 0.2rem rgb(248 108 107 / 25%) !important' : 'none',
        },
        borderColor: isInvalid ? '#f86c6b' : '#e4e7ea',
        // textOverflow: "ellipsis",
        // overflow: "hidden",
        // whiteSpace: "nowrap",
      }),
      // dropdownIndicator: (base) => ({
      //   ...base,
      //   padding: 0,
      // })
    };
    let {
      name,
      className,
      styles,
      value,
      placeholder,
      options,
      onChange,
      isDisabled,
      isClearable,
      isMulti,
      defaultValue,
      // property for async select
      key,
      async,
      loadOptions,
      defaultOptions,
      cacheOptions,
      onInputChange,
      // from input component
      isInvalid,
      isDeleteDropdown,
      showCheckbox = false,
      onMenuClose,
      onBlur,
      isCreateable = false,
      menuPortalTarget,
      allowSort = false
    } = this.props;

    const SortableSelect = SortableContainer(async ? AsyncSelect : Select);

    let style = styles ?
      {
        ...stylesReactSelect,
        ...styles
      }
      :
      null;
  
    const onSortEnd = ({ oldIndex, newIndex }) => {
      const newValue = arrayMove(value, oldIndex, newIndex);
      // setSelected(newValue);
      onChange(newValue);
    };

    if (allowSort) {
      return (
        <React.Fragment>
          <SortableSelect
            useDragHandle
            // react-sortable-hoc props:
            axis="xy"
            onSortEnd={onSortEnd}
            distance={4}
            // helperClass={""}
            // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
            getHelperDimensions={({ node }) => node.getBoundingClientRect()}
            // react-select props:
            helperClass={`sortable-index`}
            styles={style || stylesReactSelect}
            isMulti
            options={options}
            value={value}
            onChange={onChange}
            menuPortalTarget={menuPortalTarget}
            cacheOptions={cacheOptions}
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            isClearable={isClearable}
            components={{
              MultiValue: SortableMultiValue,
              MultiValueLabel: SortableMultiValueLabel
            }}
            closeMenuOnSelect={false}
          />
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          {( !async && isCreateable ) ?
              showCheckbox ?
                <CreatableSelect
                  className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
                  name={name}
                  styles={style || stylesReactSelect}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '0.25rem',
                    colors: {
                      ...theme.colors,
                      text: 'orangered',
                      primary: '#8ad4ee',
                    }
                  })}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  isClearable={isClearable}
                  placeholder={placeholder}
                  value={value}
                  options={options}
                  onChange={onChange}
                  isDisabled={isDisabled}
                  isMulti={isMulti}
                  onMenuClose={onMenuClose}
                  onBlur={onBlur}
                  defaultValue={defaultValue}
                  components={{
                    Option
                  }}
                  menuPortalTarget={menuPortalTarget}
                />
              :
                <CreatableSelect
                  className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
                  name={name}
                  styles={style || stylesReactSelect}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '0.25rem',
                    colors: {
                      ...theme.colors,
                      text: 'orangered',
                      primary: '#8ad4ee',
                    }
                  })}
                  isClearable={isClearable}
                  placeholder={placeholder}
                  value={value}
                  options={options}
                  onChange={onChange}
                  isDisabled={isDisabled}
                  isMulti={isMulti}
                  defaultValue={defaultValue}
                  menuPortalTarget={menuPortalTarget}
                />
            :
            ( !async && !isCreateable ) &&
            (
              showCheckbox ?
                <Select
                  className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
                  name={name}
                  styles={style || stylesReactSelect}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '0.25rem',
                    colors: {
                      ...theme.colors,
                      text: 'orangered',
                      primary: '#8ad4ee',
                    }
                  })}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  isClearable={isClearable}
                  placeholder={placeholder}
                  value={value}
                  options={options}
                  onChange={onChange}
                  isDisabled={isDisabled}
                  isMulti={isMulti}
                  onMenuClose={onMenuClose}
                  onBlur={onBlur}
                  defaultValue={defaultValue}
                  components={{
                    Option
                  }}
                  menuPortalTarget={menuPortalTarget}
                />
              :
              <Select
                className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
                name={name}
                styles={style || stylesReactSelect}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: '0.25rem',
                  colors: {
                    ...theme.colors,
                    text: 'orangered',
                    primary: '#8ad4ee',
                  }
                })}
                isClearable={isClearable}
                placeholder={placeholder}
                value={value}
                options={options}
                onChange={onChange}
                isDisabled={isDisabled}
                isMulti={isMulti}
                defaultValue={defaultValue}
                menuPortalTarget={menuPortalTarget}
              />
            )
          } 
          {/* for case async  */}
          { async && (
            <AsyncSelect
              key={key}
              isMulti={isMulti}
              className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
              name={name}
              value={value}
              styles={style || stylesReactSelect}
              placeholder={placeholder}
              cacheOptions={cacheOptions}
              defaultOptions={defaultOptions}
              loadOptions={loadOptions}
              onChange={onChange}
              onInputChange={onInputChange}
              isClearable={isClearable}
              isDisabled={isDisabled}
              components={isDeleteDropdown ? { DropdownIndicator: () => null, IndicatorSeparator: () => null } : ''}
              menuPortalTarget={menuPortalTarget}
            />
          )}
          {( async && isCreateable ) && (
              <AsyncCreatableSelect
                key={key}
                isMulti={isMulti}
                className={`form-error ${isInvalid ? 'invalid' : ''} ${className}`}
                name={name}
                value={value}
                styles={style || stylesReactSelect}
                placeholder={placeholder}
                cacheOptions={cacheOptions}
                defaultOptions={defaultOptions}
                loadOptions={loadOptions}
                onChange={onChange}
                onInputChange={onInputChange}
                isClearable={isClearable}
                isDisabled={isDisabled}
                components={isDeleteDropdown ? { DropdownIndicator: () => null, IndicatorSeparator: () => null } : ''}
                menuPortalTarget={menuPortalTarget}
              />
          )}
        </React.Fragment>
      )
    }
  }
}
export default ReactSelectComponent;

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="d-flex">
          <input
            className="mr-2"
            style={{ marginTop: '2px' }}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <div>{props.label}</div>
        </div>
      </components.Option>
    </div>
  );
};
